import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import CompletedTaskItem from "../../components/TaskItem/CompletedTaskItem";
import TaskItem from "../../components/TaskItem/TaskItem";
// import CompletedDailyTaskItem from "../../components/TaskItem/CompletedDailyTaskItem";
import kucoinBanner from "../../assets/kuCoinBanner.svg";
import bitgetBanner from "../../assets/bitgetBanner.svg";
import bitgetArrow from "../../assets/bitgetArrow.png";
import buyWodBanner from "../../assets/buyWodBanner.png";
import openChestBanner from "../../assets/openChestBanner.png";
import tooltip from "../../assets/tooltip.svg";
import OutsideClickHandler from "react-outside-click-handler";

const EarnPartner = ({ tasks, completedTasks, handleCompleteTask }) => {
  const { partnerId } = useParams();

  const [filteredTasks, setFilteredTasks] = useState([]);
  const [filteredCompleted, setFilteredCompleted] = useState([]);
  const [wodTasks, setWodTasks] = useState([]);
  const [completedWodTasks, setCompletedWodTasks] = useState([]);
  const [tooltipInfo, setTooltipInfo] = useState(false);
  const [chestTasks, setChestTasks] = useState([]);
  const [completedChestTasks, setCompletedChestTasks] = useState([]);

  useEffect(() => {
    setFilteredTasks(tasks.filter((item) => item.partner === partnerId));
    setFilteredCompleted(
      completedTasks.filter((item) => item.partner === partnerId)
    );
    setWodTasks(
      tasks.filter(
        (item) => item.type === "buy_wod" && item.partner === "world-of-dypians"
      )
    );
    setCompletedWodTasks(
      completedTasks.filter(
        (item) => item.type === "buy_wod" && item.partner === "world-of-dypians"
      )
    );
    setChestTasks(
      tasks.filter(
        (item) =>
          item.type === "open_chest" && item.partner === "world-of-dypians"
      )
    );
    setCompletedChestTasks(
      completedTasks.filter(
        (item) =>
          item.type === "open_chest" && item.partner === "world-of-dypians"
      )
    );
  }, [completedTasks, tasks, partnerId]);

  // const dummyKucoinTasks = [
  //   {
  //     partner: 'kucoin',
  //     title: 'Follow KuCoin on X to earn 100 points.',
  //     type: 'twitter',
  //     action: 'follow',
  //     link: 'https://x.com/kucoincom',
  //     reward: 100
  //   },
  //   {
  //     partner: 'kucoin',
  //     title: 'Register on KuCoin & Verify to earn 500 points.',
  //     type: 'kucoin',
  //     action: 'create',
  //     link: 'https://x.com/kucoincom',
  //     reward: 100
  //   }
  // ]

  return (
    <div className="container-fluid earn-wrapper pt-4 pb-3 d-flex flex-column justify-content-between">
      <div className="d-flex flex-column gap-2 ">
        {partnerId === "kucoin" && <img src={kucoinBanner} alt="" />}
        {partnerId === "buy_wod" && <img src={buyWodBanner} alt="" />}
        {partnerId === "bitget" && <img src={bitgetBanner} alt="" />}

        {partnerId === "open_chest" && <img src={openChestBanner} alt="" />}
        {partnerId === "buy_wod" && (
          <div className="position-relative d-flex align-items-center justify-content-end">
            <img
              src={tooltip}
              width={20}
              height={20}
              style={{ cursor: "pointer" }}
              alt=""
              onClick={() => setTooltipInfo(true)}
            />
            <OutsideClickHandler onOutsideClick={() => setTooltipInfo(false)}>
              <div
                className={`daily-session-tooltip-content-wrapper ${
                  tooltipInfo && "daily-session-tooltip-active"
                }`}
                style={{ left: "auto", right: "0" }}
              >
                <span style={{ color: "#FF8168" }}>
                  NOTE: You need to hold the $WOD amount in the wallet
                  associated to this account in order to complete the task
                </span>
              </div>
            </OutsideClickHandler>
          </div>
        )}
        <div className="home-tasks-container d-flex flex-column gap-2 position-relative">
          {partnerId === "buy_wod" ? (
            <>
              {wodTasks.map((task, index) => (
                <TaskItem
                  item={task}
                  key={index}
                  handleCompleteTask={handleCompleteTask}
                  page={"partner"}
                />
              ))}
              {completedWodTasks.map((task, index) => (
                <CompletedTaskItem item={task} key={index} page={"partner"} />
              ))}
            </>
          ) : partnerId === "open_chest" ? (
            <>
              {chestTasks.map((task, index) => (
                <TaskItem
                  item={task}
                  key={index}
                  handleCompleteTask={handleCompleteTask}
                  page={"partner"}
                />
              ))}
              {completedChestTasks.map((task, index) => (
                <CompletedTaskItem item={task} key={index} page={"partner"} />
              ))}
            </>
          ) : partnerId === "bitget" ? (
            <>
              {filteredTasks.map((task, index) => (
                <TaskItem
                  item={task}
                  key={index}
                  handleCompleteTask={handleCompleteTask}
                  page={"partner"}
                />
              ))}
              {filteredCompleted.map((task, index) => (
                <CompletedTaskItem item={task} key={index} page={"partner"} />
              ))}
            </>
          ) : (
            <>
              {filteredTasks.map((task, index) => (
                <TaskItem
                  item={task}
                  key={index}
                  handleCompleteTask={handleCompleteTask}
                  page={"partner"}
                />
              ))}
              {filteredCompleted.map((task, index) => (
                <CompletedTaskItem item={task} key={index} page={"partner"} />
              ))}
            </>
          )}

          {partnerId === "bitget" && (
            <div className="d-flex flex-column gap-3 mt-3">
              <span className="open-chest-span">
                *The UID will be verified, and any invalid entries will lead to
                disqualification.
              </span>
              <span className="open-chest-span">
                <b>
                  **To be eligible for claiming rewards you need to trade at
                  least $5 worth of WOD Token{" "}
                  <a
                    href="https://www.bitget.com/on-chain/bnb/0xb994882a1b9bd98a71dd6ea5f61577c42848b0e8"
                    target="_blank"
                    rel="noreferrer"
                  >
                    here
                  </a>
                </b>
                .
              </span>
            </div>
          )}

          {/* {partnerId === "open_chest" &&
          <div className="d-flex flex-column gap-3 mt-3">
            <span className="open-chest-span">*To open the daily bonus chests, you need to have an active <a href="https://www.worldofdypians.com/auth" target="_blank" rel="noreferrer">account in World of Dypians</a>.</span>
            <span className="open-chest-span">**Before opening the chests, you must link the same wallet in the mini-app as the game account to verify task completion.</span>
            <span className="open-chest-span">***This is a daily event where you can open chests on BNB Chain or opBNB.</span>
            <span className="open-chest-span"> Website: <a href="https://www.worldofdypians.com/account#bnb-miniapp-dailybonus" target="_blank" rel="noreferrer">www.worldofdypians.com</a></span>
          </div>
          } */}
        </div>
      </div>
      {partnerId === "bitget" && (
        <div className="bitget-promo-wrapper d-flex w-100 p-3 align-items-center justify-content-between">
          <span className="bitget-promo-span w-75">
            The first <b style={{ color: "#C888FF" }}>5,000 users</b> will get{" "}
            <b style={{ color: "#C888FF" }}>$10</b> guaranteed
          </span>
          <img src={bitgetArrow} className="bitget-arrow" alt="arrow" />
        </div>
      )}
    </div>
  );
};

export default EarnPartner;
